export const baseUrl = 'https://staging.trmstest.com'
export const baseReportUrl = 'https://staging.trmstest.com'
